import React from 'react';
import { Notifications } from '@bynder/design-system';
import { IconTime } from '@bynder/icons';
import { dispatchCustomEvent } from '../../helpers/useCustomEvent';
import { iconSizeMedium } from '../../helpers/iconSizes';

export function OutOfOfficeMenuItemOLD() {
	function openModal() {
		dispatchCustomEvent('openOutOfOfficeModal');
	}

	return (
		<>
			<a href="#" className="admin-option" id="availabilityMenu" onClick={openModal}>
				<IconTime size={iconSizeMedium} /> Out of Office
			</a>

			<Notifications />
		</>
	);
}
